import React, { useState } from "react";
import PropTypes from "prop-types";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import 'react-tabs/style/react-tabs.css';


const TabsBlock = ({tabsJson}) => {
	const tabs = JSON.parse(tabsJson);
	const [activeTabIndex, setActiveTabIndex] = useState(0);

	const handleTabSelect = (index) => {
		setActiveTabIndex(index);
	};
	return (
		<Tabs
			className="tabs-block__tabs"
			onSelect={handleTabSelect}
			focusTabOnClick={false}
			selectedIndex={activeTabIndex}
			selectedTabClassName="selected-tab"
		>
			<TabList className="tabs-block__tabs__triggers">
				{tabs.map((tab, index) => (
					<Tab className="tab-trigger" key={`${tab.title}-${index}`}>
						{tab.eyebrow && <p className="tab-trigger__eyebrow">{tab.eyebrow}</p>}
						<h4 className="tab-trigger__title">{tab.title}</h4>
						{tab.excerpt && <p className="tab-trigger__excerpt">{tab.excerpt}</p>}
					</Tab>
				))}
			</TabList>
			{tabs.map((tab, index) => (
				<TabPanel className="tabs-block__tabs__content" key={`${tab.title}-${index}`} >
					<div className="tab-content__content" dangerouslySetInnerHTML={{__html: tab.content}}></div>
				</TabPanel>
			))}
		</Tabs>
	);
};
export default TabsBlock;

TabsBlock.propTypes = {
	tabsJson: PropTypes.string,
};

